import { FileInput, TextInput } from '@obvio/ui'

import type { ReactElement } from 'react'

export function FormJoinPersonal(): ReactElement {
  return (
    <>
      <TextInput name="name" label="Full name" />
      <TextInput name="site" label="Site" optional />
      <TextInput name="social" label="Social Media Profile" optional />
      <FileInput name="resume" label="resume" renderProps={{ maxFiles: 1 }} />
    </>
  )
}
